module.exports = __webpack_public_path__ + "img/icon_item7.e34a4d41.png";